module.exports = __webpack_public_path__ + "static/media/6.738c9cb7.jpg";